import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface TablesState {
  selectedTableNumber: number
  selectedGuestsNumber: string
  selectedTableId: string
  myTables: string[]
  setSelectedTableNumber: (tableNumber: number) => void
  setSelectedGuestsNumber: (guestNumber: string) => void
  setSelectedTableId: (tableId: string) => void
  addMyTable: (tableId: string) => void
  removeMyTable: (tableId: string) => void
  resetMyTables: () => void
  resetSelection: () => void
}

const initialState = {
  selectedTableNumber: 0,
  selectedGuestsNumber: '',
  selectedTableId: '',
  myTables: []
}

const useTablesStore = create<TablesState>()(
  persist(
    set => ({
      ...initialState,
      setSelectedTableNumber: tableNumber =>
        set({ selectedTableNumber: tableNumber }),
      setSelectedGuestsNumber: guestsNumber =>
        set({ selectedGuestsNumber: guestsNumber }),
      setSelectedTableId: tableId => set({ selectedTableId: tableId }),
      addMyTable: tableId =>
        set(state => ({
          myTables: state.myTables.includes(tableId)
            ? state.myTables
            : [...state.myTables, tableId]
        })),
      removeMyTable: tableId =>
        set(state => ({
          myTables: state.myTables.filter(id => id !== tableId)
        })),
      resetMyTables: () => set({ myTables: [] }),
      resetSelection: () => set(initialState)
    }),
    {
      name: 'tables-storage'
    }
  )
)

export default useTablesStore
